import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/site";

const FaqSection = ({ heading = "Frequently Asked Questions" }) => {
  return (
    <section data-testid="faq-section" id="faq" className="py-20 md:py-32 bg-white">
      <div className="section-container grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="label-xs text-[var(--ct-primary)] mb-3">Moving FAQ — Casper & Wyoming</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-[var(--ct-primary)] tracking-tight" style={{ fontFamily: "Outfit" }}>
            {heading}
          </h2>
          <p className="mt-5 text-[var(--ct-text-muted)]">
            Answers to the most common questions we hear from families and businesses moving in Casper, Mills,
            and across Wyoming. Don't see your question? Call us any time at{" "}
            <a href="tel:+13072658291" className="font-semibold text-[var(--ct-secondary)]">(307) 265-8291</a>.
          </p>
        </div>

        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-b border-[var(--ct-border)]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-semibold text-[var(--ct-primary)] text-base md:text-lg hover:no-underline" style={{ fontFamily: "Outfit" }}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[var(--ct-text-muted)] leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
